const images = [
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-vintage-vc-s11075-c10-sunglasses_g_3370_6_02_22.jpg",
    bgc: "FFFFFF",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-vintage-vc-s11075-c10-sunglasses_g_3371_6_02_22.jpg",
    bgc: "FFFFFF",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-wired-up-vc-s11075-c10-sunglasses_csvfile-1661430173981-22_aug_theme_m-f127167_200378.jpg",
    bgc: "EAE9E5",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-wired-up-vc-s11075-c10-sunglasses_csvfile-1661430186675-22_aug_theme_m-f127168_200378.jpg",
    bgc: "EAE9E5",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-wired-up-vc-s11075-c10-sunglasses_csvfile-1661430200511-22_aug_theme_m-f127316_200378.jpg",
    bgc: "EFEEE9",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-wired-up-vc-s11075-c10-sunglasses_csvfile-1661430213485-22_aug_theme_m-f127319_200378.jpg",
    bgc: "EFEEE9",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-vintage-vc-s11075-c10-sunglasses_g_3373_6_02_22.jpg",
    bgc: "FFFFFF",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-vintage-vc-s11075-c10-sunglasses_g_3374_6_02_22.jpg",
    bgc: "FFFFFF",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-vintage-vc-s11075-c10-sunglasses_g_3376_6_02_22.jpg",
    bgc: "FFFFFF",
    id: Date.now(),
  },
  {
    link: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/black-grey-full-rim-aviator-vincent-chase-polarized-vintage-vc-s11075-c10-sunglasses_g_3371_image_pla_6_02_22.jpg",
    bgc: "FFFFFF",
    id: Date.now(),
  },
];

export default images;
